"use strict";
/*
 * Created on 15. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * DTO object for release "Total detail" tab. Object represents one product category of a release
 * and aggregated values for this category. Categories that correspond to the release parts have also associated
 * workflow status available.
 *
 * @author Radek Beran
 */


var AbstractReleaseTotalDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AbstractReleaseTotalDTO, _DomainObject_1$Domai);

  /**
   * Constructs new release total info object.
   * @param categoryId id of category
   * @param approvalStatus approval status is filled in case this is ROOT category (approval data for the whole release)
   * or release-part category (approval data for part of release)
   * @param actionFeasibilities feasibilities of workflow actions
   */
  function AbstractReleaseTotalDTO(categoryId, approvalStatus, actionFeasibilities, realImpact) {
    var _this;

    _classCallCheck(this, AbstractReleaseTotalDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleaseTotalDTO).call(this));
    _this.categoryId = categoryId;
    _this.approvalStatus = approvalStatus;
    _this.actionFeasibilities = actionFeasibilities;
    _this.realImpact = realImpact;
    return _this;
  }

  return AbstractReleaseTotalDTO;
}(DomainObject_1.DomainObject);

exports.AbstractReleaseTotalDTO = AbstractReleaseTotalDTO;